export default __webpack_public_path__ + "media/shipment/venipak-dfc1b092.svg";